/* eslint-disable no-console */
import mixpanel from "mixpanel-browser"

import { ensureInitialized } from "./initMixpanel"

type EventProperties = Record<string, unknown>

export const trackEvent = (eventName: string, properties?: EventProperties) => {
  console.log("trackevent called")
  if (!ensureInitialized()) {
    console.log("mixpanel not initialized")
    console.warn({ eventName }, "Mixpanel not initialized, event not tracked")
    return
  }

  try {
    console.log("Tracking event:", eventName, properties)
    mixpanel.track(eventName, {
      ...properties,
      url: typeof window !== "undefined" ? window.location.href : "",
      path: typeof window !== "undefined" ? window.location.pathname : "",
      timestamp: new Date().toISOString(),
    })
  } catch (error) {
    console.error("Error tracking event", error)
  }
}
